class Svg {
    constructor(name) {
        let div = document.createElement("div");
        div.innerHTML = require("../../../public/svg/" + name + ".svg"); // change to wherever your svg files are

        let fragment = document.createDocumentFragment();

        fragment.appendChild(div);

        this.svg = fragment.querySelector("svg");
    }

    classes(classes) {
        if (classes) {
            if (!!this.svg.classList) {
                classes.split(" ").forEach(className => {
                    if (className.length) {
                        this.svg.classList.add(className);
                    }
                });
            } else if (this.svg.nodeName === "svg") {
                this.svg.setAttribute("class", classes);
            }
        }

        return this;
    }

    width(width) {
        if (width) {
            this.svg.setAttribute("width", width);
        }

        return this;
    }

    height(height) {
        if (height) {
            this.svg.setAttribute("height", height);
        }

        return this;
    }

    toString() {
        return new XMLSerializer().serializeToString(this.svg);
    }
}

export default {
    props: {
        name: {
            default: ""
        },
        classes: {
            default: ""
        },
        width: {
            default: ""
        },
        height: {
            default: ""
        }
    },

    render(h) {
        return h("div", {
            attrs: {
                class: "flex items-center"
            },
            domProps: {
                innerHTML: new Svg(this.name)
                    .classes(this.classes)
                    .width(this.width)
                    .height(this.height)
            }
        });
    }
};
